import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
  ResponsiveModalTrigger,
} from '@/components/extension/responsive-modal'
import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

type BenefitItemProps = {
  imageSrc: string
  benefitKey: string
}

const BenefitItem = ({ imageSrc, benefitKey }: BenefitItemProps) => {
  const t = useTranslations()
  return (
    <div className='flex flex-col items-center text-center'>
      <div className='mb-4 w-16 lg:w-28'>
        <Image
          src={ImageHelper.getImageUrl(imageSrc)}
          alt='Benefit'
          width={112}
          height={112}
        />
      </div>
      <h4 className='mb-2 font-medium'>
        {t(
          `landing_coolclub_page.coolcash.modal.benefits.${benefitKey}.title` as never
        )}
      </h4>
      <p className='text-sm text-gray-600'>
        {t(
          `landing_coolclub_page.coolcash.modal.benefits.${benefitKey}.description` as never
        )}
      </p>
    </div>
  )
}

const COOLCASH_BENEFITS = [
  {
    imageSrc: '/image/January2025/mceclip12.png',
    benefitKey: 'direct',
  },
  {
    imageSrc: '/image/January2025/mceclip11.png',
    benefitKey: 'voucher',
  },
  {
    imageSrc: '/image/January2025/mceclip10.png',
    benefitKey: 'care_share',
  },
]

export const CoolcashBenefitModal = () => {
  const t = useTranslations()
  return (
    <ResponsiveModal>
      <ResponsiveModalTrigger asChild>
        <Button variant={'black'}>
          {t('landing_coolclub_page.coolcash.view_detail')}
        </Button>
      </ResponsiveModalTrigger>
      <ResponsiveModalContent
        className='gap-0 border-none bg-[#F4F3F1] px-5 py-6 lg:max-w-[800px] lg:py-10'
        aria-describedby={'modal-login'}
      >
        <ResponsiveModalTitle hidden />
        <ResponsiveModalDescription hidden />
        <div>
          <p className='text-center font-criteria text-3xl font-semibold leading-tight lg:text-[44px]'>
            {t('landing_coolclub_page.coolcash.modal.title')}
          </p>
          <p className='text-center text-base text-neutral-600 md:px-6'>
            {t('landing_coolclub_page.coolcash.modal.description')}
          </p>
          <div className='mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-10 md:px-6'>
            {COOLCASH_BENEFITS.map((benefit) => (
              <BenefitItem {...benefit} key={benefit.benefitKey} />
            ))}
          </div>
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
